import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication/authentication.service';

@Component({
  selector: 'ftl-quote-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  isLoggedIn = false;

  constructor(private authService: AuthenticationService) {
  }

  ngOnInit() {    
    var authService = this.authService;
    this.authService.loggedInObservable.subscribe(() => {
      this.isLoggedIn = authService.isLoggedIn();
    });
  }
}
